import moment from 'moment'

function formatCheckInDays (stayLengths) {
  const checkInDays = []
  stayLengths.forEach(([min, _, checkOut], day) => {
    if (min > 0) {
      checkInDays.push(
        {
          'day': moment().day(day).format('ddd'),
          'turnaround': checkOut === 1,
        }
      )
    }
  })

  if (!checkInDays.length) {
    return [{ day: 'None selected', turnaround: false }]
  }

  // move sunday to the end
  if (checkInDays[0].day === 'Sun') {
    checkInDays[7] = checkInDays[0]
    checkInDays.shift()
  }

  return checkInDays.filter((item) => item)
}

function formatRates (rate) {
  if (rate.rate > 0) {
    return ['Everyday £(' + rate.rate + ')']
  }

  const days = ['Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat', 'Sun']

  const filterd = rate.dayOfWeekRates.filter((item, i) => {
    return item[0] > 0
  })

  if (filterd.length === 0) {
    return ['Not applied']
  }

  const formattedRates = filterd.map((element, i) => {
    return days[i] + ' (£' + element[0] + ')'
  })

  return formattedRates
}

export {
  formatCheckInDays,
  formatRates,
}
